"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CryptoForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _definitions = require("@ppay/definitions");
var _useContextSelector = require("use-context-selector");
var _reactstrap = require("reactstrap");
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _TickerConverter = require("./TickerConverter");
var _TickerGroup = require("./TickerGroup");
var _NetworkGroup = require("./NetworkGroup");
var _BalanceGroup = require("./BalanceGroup");
var _hooks = require("../../../../../hooks");
var _page = require("../page");
var _providers = require("../providers");
var _Footer = require("./Footer");
var _confirmModal = require("../confirm-modal");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CryptoForm = function CryptoForm(_ref) {
  var _balance$value, _balance$converted;
  var children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var onFormSubmit = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.onFormSubmit;
  });
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  var tickers = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.tickers;
  });
  var setInfo = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.setInfo;
  });
  var convertedTicker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.convertedTicker;
  });
  var _useContext = (0, _react.useContext)(_providers.CreateWithdrawContext),
    useCreateWithdraw = _useContext.useCreateWithdraw;
  var _useCreateWithdraw = useCreateWithdraw(),
    withdrawState = _useCreateWithdraw.withdrawState;
  var _useContext2 = (0, _react.useContext)(_providers.BalanceContext),
    useBalances = _useContext2.useBalances,
    balanceName = _useContext2.balanceName;
  var _useBalances = useBalances(),
    getBalanceByTicker = _useBalances.getBalanceByTicker,
    balances = _useBalances.balances;
  var balance = getBalanceByTicker(ticker);
  var _useSendForm = (0, _hooks.useSendForm)({
      withdrawDone: withdrawState.done
    }),
    formProviderProps = _useSendForm.formProviderProps,
    blockchains = _useSendForm.blockchains,
    blockchain = _useSendForm.blockchain,
    setBlockchain = _useSendForm.setBlockchain,
    isFormValid = _useSendForm.isFormValid;
  var _useSendFee = (0, _hooks.useSendFee)({
      isFormValid: isFormValid,
      blockchain: blockchain
    }),
    value = _useSendFee.value;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: formProviderProps.handleSubmit(onFormSubmit)
  }, children, /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_TickerGroup.TickerGroup, {
    ticker: ticker,
    tickers: tickers,
    balances: balances,
    onTickerChange: function onTickerChange(ticker) {
      return setInfo(_definitions.FIAT_TICKERS.includes(ticker) ? {
        ticker: ticker,
        amount: ''
      } : {
        ticker: ticker
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_NetworkGroup.NetworkGroup, {
    blockchain: blockchain,
    blockchains: blockchains,
    onBlockchainChange: setBlockchain
  }))), /*#__PURE__*/_react.default.createElement(_BalanceGroup.BalanceGroup, {
    balanceName: balanceName,
    ticker: ticker,
    convertedTicker: convertedTicker,
    balance: (_balance$value = balance === null || balance === void 0 ? void 0 : balance.value) !== null && _balance$value !== void 0 ? _balance$value : '0',
    convertedBalance: (_balance$converted = balance === null || balance === void 0 ? void 0 : balance.converted) !== null && _balance$converted !== void 0 ? _balance$converted : '0'
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('walletAddress')), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: formProviderProps.control,
    inputProps: {
      name: 'address',
      type: 'text',
      autoComplete: 'on'
    }
  })), /*#__PURE__*/_react.default.createElement(_TickerConverter.TickerConverter, {
    control: formProviderProps.control,
    ticker: ticker,
    convertedTicker: convertedTicker,
    onAmountChange: function onAmountChange(amount) {
      formProviderProps.setValue('amount', amount);
    },
    onConvertedAmountChange: function onConvertedAmountChange(amount) {
      formProviderProps.setValue('convertedAmount', amount);
    },
    onConvertedTickerChange: function onConvertedTickerChange(convertedTicker) {
      return setInfo({
        convertedTicker: convertedTicker
      });
    },
    trigger: formProviderProps.trigger
  }), /*#__PURE__*/_react.default.createElement(_Footer.Footer, {
    disabled: !value
  }), /*#__PURE__*/_react.default.createElement(_confirmModal.CryptoConfirmModal, {
    blockchain: blockchain
  }));
};
exports.CryptoForm = CryptoForm;